import React from 'react';
import henry from '../images/henry.jpeg';
import tayler from '../images/tayler.jpeg';
import fatherAndSon from '../images/son.jpeg'
import businessman from '../images/businessman.jpeg'
import businessman1 from '../images/businessman1.jpeg'
import phone from '../images/phone.jpeg'
import anna from '../images/anna.jpeg'
import samue from '../images/samue.jpeg'
import sophia from '../images/sophia.jpeg'
import product1 from '../images/product1.jpeg'
import product2 from '../images/product2.jpeg'
import product3 from '../images/product3.jpeg'
import product4 from '../images/product4.jpeg'
import product5 from '../images/product5.jpeg'
import product6 from '../images/product6.jpeg'
import product7 from '../images/product7.jpeg'

const Home = ({ setCurrentPage }) => {
  const featuredProducts = [
    {
      id: 1,
      name: "EMF Protection Anti-Radiation Stickers For Phone Laptop Ipad",
      originalPrice: "$25.99",
      salePrice: "$21.31",
      image: product1,
      isOnSale: true,
      isNew: false
    },
    {
      id: 2,
      name: "Bio Magnetic Therapy Necklace For Pain Relief",
      originalPrice: null,
      salePrice: "$31.99",
      image: product2,
      isOnSale: true,
      isNew: false
    },
    {
      id: 3,
      name: "Bio Magnetic Anti-Radiation Therapy Bracelet - Stainless & Ions",
      originalPrice: "$30.07",
      salePrice: "$24.99",
      image: product3,
      isOnSale: true,
      isNew: false
    },
    {
      id: 4,
      name: "EMF Protection Necklace - Quantum Energy Pendant With...",
      originalPrice: "$25.66",
      salePrice: "$21.99",
      image: product4,
      isOnSale: true,
      isNew: false
    },
    {
      id: 5,
      name: "Golden Protection Pendant",
      originalPrice: null,
      salePrice: "$29.99",
      image: product5,
      isOnSale: true,
      isNew: true
    },
    {
      id: 6,
      name: "Silver Energy Necklace",
      originalPrice: null,
      salePrice: "$34.99",
      image: product6,
      isOnSale: true,
      isNew: true
    },
    {
      id: 7,
      name: "Copper Therapy Bracelet",
      originalPrice: null,
      salePrice: "$27.99",
      image: product7,
      isOnSale: true,
      isNew: true
    }
  ];

  return (
    <div className="bg-gradient-to-b from-blue-50 to-gray-100 pt-16 pb-16">
      {/* Hero Section */}
      <div className="max-w-7xl mx-auto px-4 grid lg:grid-cols-2 gap-12 items-center">
        {/* Left Content */}
        <div className="space-y-6">
          <div className="text-red-400 text-lg font-medium">
            Feel Safe and Protected from EMF Radiation
          </div>
          
          <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
            Nurture Your Energy,<br />
            Protect Your Loved Ones
          </h1>
          
          <p className="text-xl text-gray-600 leading-relaxed">
            Empower yourself and those you care about with trusted EMF protection designed 
            to support your wellness and peace of mind.
          </p>
          
          <button 
            onClick={() => setCurrentPage('shop')}
            className="bg-blue-500 hover:bg-blue-600 text-white px-8 py-4 rounded-full text-lg font-semibold transition-colors"
          >
            Shop EMF Protection for Peace of Mind
          </button>
          
          {/* Trust Indicators */}
         <div className="flex items-center space-x-4 pt-4">
  <div className="flex -space-x-2">
    <img
      src={henry} // Replace with your image path (e.g., imported or public folder path)
      alt="User 1"
      className="w-10 h-10 rounded-full border-2 border-white object-cover"
    />
    <img
      src={tayler}
      alt="User 2"
      className="w-10 h-10 rounded-full border-2 border-white object-cover"
    />
    <img
      src={businessman}
      alt="User 3"
      className="w-10 h-10 rounded-full border-2 border-white object-cover"
    />
    <img
      src={henry}
      alt="User 4"
      className="w-10 h-10 rounded-full border-2 border-white object-cover"
    />
    <img
      src={businessman1}
      alt="User 5"
      className="w-10 h-10 rounded-full border-2 border-white object-cover"
    />
  </div>
  <div className="text-gray-700 font-medium">
    Trusted by 50,000+ Families & Individuals for Healthier Living
  </div>
</div>
        </div>
        
        {/* Right Content - Images */}
       <div className="space-y-6">
  {/* Top Image */}
 <div className="mx-auto max-w-4xl w-full h-64 relative rounded-2xl overflow-hidden shadow-lg bg-white">
  <img
    src={fatherAndSon}
    alt="Father and Son with Tablet"
    className="w-full h-full object-cover"
  />
</div>




  {/* Bottom Row */}
  <div className="grid grid-cols-2 gap-6">
    {/* Business Man */}
    <div className="relative rounded-2xl overflow-hidden shadow-lg">
      <img
        src={businessman}
        alt="Professional Business Man"
        className="w-full h-48 object-cover"
      />
    </div>

    {/* Phone & Laptop */}
    <div className="relative rounded-2xl overflow-hidden shadow-lg">
      <img
        src={phone} // change this path to your image
        alt="Phone and Laptop"
        className="w-full h-48 object-cover"
      />
    </div>
  </div>
</div>

      </div>

      {/* Why Us Section */}
      <div className="max-w-7xl mx-auto px-4 py-16">
        <h2 className="text-4xl font-bold text-center text-gray-900 mb-16">Why us?</h2>
        
        <div className="grid lg:grid-cols-3 gap-12">
          {/* Trusted EMF Experts */}
          <div className="text-center space-y-4">
            <div className="w-16 h-16 bg-red-100 rounded-2xl mx-auto flex items-center justify-center mb-6">
              <div className="w-8 h-8 bg-red-400 rounded-lg flex items-center justify-center">
                <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clipRule="evenodd" />
                </svg>
              </div>
            </div>
            <h3 className="text-xl font-bold text-gray-900">Trusted EMF Experts</h3>
            <p className="text-gray-600">Over 30+ powerful solutions, trusted worldwide.</p>
          </div>

          {/* Scientifically Supported */}
          <div className="text-center space-y-4">
            <div className="w-16 h-16 bg-blue-100 rounded-2xl mx-auto flex items-center justify-center mb-6">
              <div className="w-8 h-8 bg-blue-400 rounded-lg flex items-center justify-center">
                <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M3 3a1 1 0 000 2v8a2 2 0 002 2h2.586l-1.293 1.293a1 1 0 101.414 1.414L10 15.414l2.293 2.293a1 1 0 001.414-1.414L12.414 15H15a2 2 0 002-2V5a1 1 0 100-2H3zm11.707 4.707a1 1 0 00-1.414-1.414L10 9.586 8.707 8.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
              </div>
            </div>
            <h3 className="text-xl font-bold text-gray-900">Scientifically Supported</h3>
            <p className="text-gray-600">Developed with evidence-based research for reliable protection.</p>
          </div>

          {/* Advanced Bio-Protection */}
          <div className="text-center space-y-4">
            <div className="w-16 h-16 bg-yellow-100 rounded-2xl mx-auto flex items-center justify-center mb-6">
              <div className="w-8 h-8 bg-yellow-400 rounded-lg flex items-center justify-center">
                <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" />
                </svg>
              </div>
            </div>
            <h3 className="text-xl font-bold text-gray-900">Advanced Bio-Protection</h3>
            <p className="text-gray-600">Harnessing the latest bio-energetic technology for dual-layer defense.</p>
          </div>
        </div>
      </div>

      {/* Why EMF Protection Matters Section */}
      <div className="bg-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Why EMF Protection Matters: Science-Backed Health Benefits
            </h2>
            <p className="text-gray-600 max-w-4xl mx-auto">
              Backed by studies on the health impacts of electromagnetic exposure, EMF protection offers various wellness benefits.
              Discover the supportive effects EMF protection can have on your overall health.
            </p>
          </div>

          <div className="grid lg:grid-cols-3 gap-8 mb-8">
            {/* Protects Cellular Health */}
            <div className="text-center space-y-4">
              <div className="w-16 h-16 bg-blue-500 rounded-full mx-auto flex items-center justify-center mb-6">
                <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900">Protects Cellular Health</h3>
              <p className="text-gray-600">
                May help reduce oxidative stress and mitigate cellular damage from EMF.
              </p>
            </div>

            {/* Enhances Immune System */}
            <div className="text-center space-y-4">
              <div className="w-16 h-16 bg-blue-500 rounded-full mx-auto flex items-center justify-center mb-6">
                <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900">Enhances Immune System Resilience</h3>
              <p className="text-gray-600">
                Helps the body manage immune response more effectively, reducing fatigue.
              </p>
            </div>

            {/* Supports Blood Cell Function */}
            <div className="text-center space-y-4">
              <div className="w-16 h-16 bg-blue-500 rounded-full mx-auto flex items-center justify-center mb-6">
                <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 000 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900">Supports Balanced Blood Cell Function</h3>
              <p className="text-gray-600">
                Supports balanced white and red blood cell activity disrupted by EMF exposure.
              </p>
            </div>
          </div>

          <div className="grid lg:grid-cols-3 gap-8">
            {/* Neurological Stability */}
            <div className="text-center space-y-4">
              <div className="w-16 h-16 bg-blue-500 rounded-full mx-auto flex items-center justify-center mb-6">
                <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 000 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900">Promotes Neurological Stability</h3>
              <p className="text-gray-600">
                Supports brain function and cognitive performance under EMF exposure.
              </p>
            </div>

            {/* Blood-Brain Barrier */}
            <div className="text-center space-y-4">
              <div className="w-16 h-16 bg-blue-500 rounded-full mx-auto flex items-center justify-center mb-6">
                <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M18 8A6 6 0 006 8v2.7l2.9 2.9a1 1 0 001.4 0l.7-.7 1.4 1.4a1 1 0 001.4 0l2.9-2.9V8z" clipRule="evenodd" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900">Preserves Blood-Brain Barrier</h3>
              <p className="text-gray-600">
                Helps maintain the integrity of this critical protective barrier.
              </p>
            </div>

            {/* Reduces EMF Sensitivity */}
            <div className="text-center space-y-4">
              <div className="w-16 h-16 bg-blue-500 rounded-full mx-auto flex items-center justify-center mb-6">
                <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414z" clipRule="evenodd" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900">Reduces EMF Sensitivity Symptoms</h3>
              <p className="text-gray-600">
                May help alleviate symptoms associated with electromagnetic hypersensitivity.
              </p>
            </div>
          </div>
        </div>
      </div>

{/* Featured Products Section */}
<div className="bg-gray-50 py-16">
  <div className="max-w-7xl mx-auto px-4">
    <div className="flex justify-between items-center mb-12">
      <h2 className="text-4xl font-bold text-gray-900">FEATURED PRODUCTS</h2>
      <button 
        onClick={() => setCurrentPage('shop')}
        className="text-gray-600 hover:text-gray-900 font-medium text-lg transition-colors"
      >
        View All
      </button>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {featuredProducts.map((product) => (
        <div key={product.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
          <div className="relative">
            {product.isOnSale && (
              <div className="absolute top-4 left-4 bg-red-500 text-white px-3 py-1 rounded-md text-sm font-medium z-10">
                Sale
              </div>
            )}
            {product.isNew && (
              <div className="absolute top-4 left-4 bg-gray-800 text-white px-3 py-1 rounded-md text-sm font-medium z-10">
                New
              </div>
            )}
            <div className="h-64 bg-gray-100">
              <img 
                src={product.image} 
                alt={product.name}
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div className="p-6">
            <h3 className="text-gray-900 font-medium mb-4 text-center leading-snug">
              {product.name}
            </h3>
            <div className="text-center">
              {product.originalPrice ? (
                <div className="space-x-2">
                  <span className="text-gray-400 line-through text-lg">{product.originalPrice}</span>
                  <span className="text-red-500 text-xl font-bold">{product.salePrice}</span>
                </div>
              ) : (
                <span className="text-gray-900 text-xl font-bold">{product.salePrice || product.price}</span>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
</div>


      {/* EMF Exposure Section */}
      <div className="bg-gradient-to-b from-blue-50 to-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          {/* Section Header */}
          <div className="text-center mb-16">
            <div className="inline-block bg-blue-500 text-white px-8 py-3 rounded-lg text-xl font-bold mb-8">
              EMF Exposure: Proven Health Risks You Need to Know
            </div>
          </div>

          {/* Health Risks Grid */}
          <div className="grid lg:grid-cols-3 gap-8">
            {/* Sleep Disruption */}
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-6">
                <svg className="w-6 h-6 text-blue-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z" clipRule="evenodd" />
                </svg>
              </div>
              <h3 className="text-blue-500 text-lg font-bold mb-2">Disrupts Sleep & Circadian Rhythms</h3>
              <p className="text-gray-900 font-semibold mb-4">
                Up to 40% of people report poor sleep quality due to EMF exposure.
              </p>
              <p className="text-gray-600">
                EMFs disrupt melatonin production, interfering with deep sleep and natural sleep-wake cycles.
              </p>
            </div>

            {/* Stress & Immunity */}
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-6">
                <svg className="w-6 h-6 text-blue-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M3 6a3 3 0 013-3h10a1 1 0 01.8 1.6L14.25 8l2.55 3.4A1 1 0 0116 13H6a1 1 0 00-1 1v3a1 1 0 11-2 0V6z" clipRule="evenodd" />
                </svg>
              </div>
              <h3 className="text-blue-500 text-lg font-bold mb-2">Increases Stress & Weakens Immunity</h3>
              <p className="text-gray-900 font-semibold mb-4">
                Studies show a 30% increase in cortisol levels linked to EMF exposure.
              </p>
              <p className="text-gray-600">
                EMFs impact the nervous system, raising stress hormones and weakening immune defenses, making the body more vulnerable.
              </p>
            </div>

            {/* Mental Health */}
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-6">
                <svg className="w-6 h-6 text-blue-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M18 8a6 6 0 01-7.743 5.743L10 14l-2 1-1 1H4v-1l4.257-4.257A6 6 0 1118 8zm-6-2a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
                </svg>
              </div>
              <h3 className="text-blue-500 text-lg font-bold mb-2">Lowers Energy & Affects Mental Health</h3>
              <p className="text-gray-900 font-semibold mb-4">
                Linked to a 20% decrease in focus and mental clarity in clinical studies.
              </p>
              <p className="text-gray-600">
                Exposure affects brain chemistry, altering hormones and reducing mental sharpness, mood, and overall energy.
              </p>
            </div>
          </div>

          {/* CTA Button */}
          <div className="text-center mt-12">
            <button className="bg-blue-400 hover:bg-blue-500 text-white px-8 py-3 rounded-full text-lg font-medium transition-colors">
              Read more about emf
            </button>
          </div>
        </div>

        {/* Real People, Real Results Section */}
<div className="bg-white py-16">
  <div className="max-w-7xl mx-auto px-4">
    <h2 className="text-4xl font-bold text-center text-gray-900 mb-16">Real people, real results</h2>
    
    {/* First Row - 4 testimonials */}
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      <div className="bg-yellow-100 rounded-2xl p-6">
        <div className="flex items-center mb-4">
          <img src={henry} alt="Henry Davis" className="w-12 h-12 rounded-full mr-3" />
        </div>
        <div className="flex mb-4">
          {[...Array(5)].map((_, i) => (
            <svg key={i} className="w-5 h-5 text-yellow-400 fill-current" viewBox="0 0 20 20">
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
            </svg>
          ))}
        </div>
        <p className="text-gray-800 mb-4">
          When my wife and I started noticing our kids feeling fatigued after using their tablets, we knew we had to take action... It's been a wonderful change for our family!
        </p>
        <p className="text-gray-700 font-medium">- Henry Davis</p>
      </div>

      <div className="bg-purple-100 rounded-2xl p-6">
        <div className="flex items-center mb-4">
          <img src={tayler} alt="Charlotte Taylor" className="w-12 h-12 rounded-full mr-3" />
        </div>
        <div className="flex mb-4">
          {[...Array(5)].map((_, i) => (
            <svg key={i} className="w-5 h-5 text-yellow-400 fill-current" viewBox="0 0 20 20">
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
            </svg>
          ))}
        </div>
        <p className="text-gray-800 mb-4">
          After my husband started experiencing headaches from his work computer, I was desperate to find a solution... Amazing how something so simple can bring peace of mind!
        </p>
        <p className="text-gray-700 font-medium">- Charlotte Taylor</p>
      </div>

      <div className="bg-orange-100 rounded-2xl p-6">
        <div className="flex items-center mb-4">
          <img src={anna} alt="Anna Smith" className="w-12 h-12 rounded-full mr-3" />
        </div>
        <div className="flex mb-4">
          {[...Array(4)].map((_, i) => (
            <svg key={i} className="w-5 h-5 text-yellow-400 fill-current" viewBox="0 0 20 20">
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
            </svg>
          ))}
          <svg className="w-5 h-5 text-gray-300 fill-current" viewBox="0 0 20 20">
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
          </svg>
        </div>
        <p className="text-gray-800 mb-4">
          I love my EMF Quantum pendant! It's not only stylish but also incredibly effective. Highly recommend for anyone looking for EMF protection!
        </p>
        <p className="text-gray-700 font-medium">- Anna Smith</p>
      </div>

      <div className="bg-blue-100 rounded-2xl p-6">
        <div className="flex items-center mb-4">
          <img src={samue} alt="Samuel Clark" className="w-12 h-12 rounded-full mr-3" />
        </div>
        <div className="flex mb-4">
          {[...Array(4)].map((_, i) => (
            <svg key={i} className="w-5 h-5 text-yellow-400 fill-current" viewBox="0 0 20 20">
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
            </svg>
          ))}
          <svg className="w-5 h-5 text-gray-300 fill-current" viewBox="0 0 20 20">
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
          </svg>
        </div>
        <p className="text-gray-800 mb-4">
          I'm really impressed with the EMF Titan stickers! They are easy to apply and have helped me feel more protected from EMF exposure. Definitely worth it.
        </p>
        <p className="text-gray-700 font-medium">- Samuel Clark</p>
      </div>
    </div>

    {/* Second Row - Centered testimonial */}
    <div className="flex justify-center">
      <div className="bg-green-100 rounded-2xl p-6 max-w-md">
        <div className="flex items-center mb-4">
          <img src={sophia} alt="Sophia Moore" className="w-12 h-12 rounded-full mr-3" />
        </div>
        <div className="flex mb-4">
          {[...Array(5)].map((_, i) => (
            <svg key={i} className="w-5 h-5 text-yellow-400 fill-current" viewBox="0 0 20 20">
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
            </svg>
          ))}
        </div>
        <p className="text-gray-800 mb-4">
          I absolutely love my EMF Titan pendant! It's sleek and stylish, and I genuinely feel less drained after long days. Highly recommend!
        </p>
        <p className="text-gray-700 font-medium">- Sophia Moore</p>
      </div>
    </div>
  </div>
</div>

{/* Blog Post Section */}
<div className="bg-gray-50 py-16">
  <div className="max-w-7xl mx-auto px-4">
    <h2 className="text-4xl font-bold text-center text-gray-900 mb-16">BLOG POST</h2>
    
    <div className="grid lg:grid-cols-2 gap-12 items-center">
      {/* Left Content */}
      <div className="space-y-6">
        <div className="text-gray-500 text-sm font-medium">MAY 13, 2025</div>
        <h3 className="text-2xl font-bold text-gray-900">
          WHAT MATERIALS CAN BLOCK EMF RADIATION? A COMPREHENSIVE GUIDE
        </h3>
        <p className="text-gray-600 leading-relaxed">
          Electromagnetic fields (EMF) are ubiquitous in modern life, emitted by smartphones, WiFi routers, power lines, and countless other devices. With growing concerns...
        </p>
        <button className="bg-blue-500 hover:bg-blue-600 text-white px-8 py-3 rounded-md font-medium transition-colors">
          VIEW DETAILS
        </button>
      </div>
      
      {/* Right Content */}
      <div className="space-y-6">
        <div className="bg-gradient-to-br from-blue-900 to-teal-600 rounded-2xl p-8 text-white relative overflow-hidden">
          <div className="relative z-10">
            <div className="w-16 h-16 bg-white/20 rounded-full mb-4 flex items-center justify-center">
              <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
              </svg>
            </div>
            <h4 className="text-xl font-bold mb-2">EMF Protection Technology</h4>
            <p className="text-blue-100">Advanced shielding solutions for modern devices</p>
          </div>
          {/* Decorative waves */}
          <div className="absolute top-0 right-0 w-32 h-32 opacity-20">
            <svg viewBox="0 0 100 100" className="w-full h-full">
              <path d="M20,20 Q50,10 80,20 T80,50 Q50,60 20,50 T20,20" fill="currentColor" />
            </svg>
          </div>
        </div>
        
        {/* Blog entries */}
        <div className="space-y-4">
          <div className="border-l-4 border-gray-200 pl-4">
            <div className="text-gray-500 text-sm mb-1">MAY 13, 2025</div>
            <h4 className="font-bold text-gray-900 mb-2">
              HOW DO EMF STICKERS WORK? A COMPLETE GUIDE
            </h4>
            <p className="text-gray-600 text-sm">
              EMF radiation is everywhere—from your smartphone, Wi-Fi router, laptop, and even smart home devices. People are starting to realize how constant exposure...
            </p>
          </div>
          
          <div className="border-l-4 border-gray-200 pl-4">
            <div className="text-gray-500 text-sm mb-1">MAY 09, 2025</div>
            <h4 className="font-bold text-gray-900 mb-2">
              HOW FAR AWAY SHOULD YOUR CELL PHONE BE WHEN YOU SLEEP?
            </h4>
            <p className="text-gray-600 text-sm">
              Your phone's always within arm's reach, right? It's your alarm, your late-night scroll buddy, maybe even your white noise machine. But keeping...
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<footer className="bg-white border-t border-gray-200 py-16">
  <div className="max-w-7xl mx-auto px-4">
    {/* Top Footer */}
    <div className="grid lg:grid-cols-4 gap-8 mb-12">
      
      {/* Learn More */}
      <div>
        <h3 className="text-gray-900 font-bold text-lg mb-6">LEARN MORE</h3>
        <ul className="space-y-3">
          <li><a href="#" className="text-gray-600 hover:text-gray-900 transition-colors">What Is EMF?</a></li>
          <li><a href="#" className="text-gray-600 hover:text-gray-900 transition-colors">Protecting Kids From EMF</a></li>
          <li><a href="#" className="text-gray-600 hover:text-gray-900 transition-colors">Pregnancy & EMF Exposure</a></li>
          <li><a href="#" className="text-gray-600 hover:text-gray-900 transition-colors">Benefits Of EMF Headphones</a></li>
          <li><a href="#" className="text-gray-600 hover:text-gray-900 transition-colors">Protect Yourself From EMF Radiation</a></li>
        </ul>
      </div>

      {/* Information */}
      <div>
        <h3 className="text-gray-900 font-bold text-lg mb-6">INFORMATION</h3>
        <ul className="space-y-3">
          <li><a href="#" className="text-gray-600 hover:text-gray-900 transition-colors">Blogs</a></li>
          <li><a href="#" className="text-gray-600 hover:text-gray-900 transition-colors">FAQs</a></li>
          <li><a href="#" className="text-gray-600 hover:text-gray-900 transition-colors">Contact</a></li>
          <li><a href="#" className="text-gray-600 hover:text-gray-900 transition-colors">About Us</a></li>
        </ul>
      </div>

      {/* Policies */}
      <div>
        <h3 className="text-gray-900 font-bold text-lg mb-6">POLICIES</h3>
        <ul className="space-y-3">
          <li><a href="#" className="text-gray-600 hover:text-gray-900 transition-colors">Privacy Policy</a></li>
          <li><a href="#" className="text-gray-600 hover:text-gray-900 transition-colors">Refund Policy</a></li>
          <li><a href="#" className="text-gray-600 hover:text-gray-900 transition-colors">Shipping Policy</a></li>
          <li><a href="#" className="text-gray-600 hover:text-gray-900 transition-colors">Terms Of Service</a></li>
        </ul>
      </div>

      {/* Newsletter */}
      <div>
        <h3 className="text-gray-900 font-bold text-lg mb-6">NEWSLETTER SIGN UP</h3>
        <p className="text-gray-600 mb-6">
          Sign up for exclusive updates, new arrivals & insider-only discounts
        </p>
        <div className="flex">
          <input
            type="email"
            placeholder="Enter your email address"
            className="flex-1 px-4 py-3 border border-gray-300 rounded-l-md focus:outline-none focus:border-blue-500"
          />
          <button className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-3 rounded-r-md font-medium transition-colors">
            SUBMIT
          </button>
        </div>
        <div className="flex space-x-4 mt-6">
          {/* Social Media Icons */}
          <a href="#" className="text-gray-400 hover:text-gray-600 transition-colors" aria-label="Twitter">
            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
              <path d="M24 4.557c-.883.392-1.832.656-2.828.775 ..."/>
            </svg>
          </a>
          <a href="#" className="text-gray-400 hover:text-gray-600 transition-colors" aria-label="Reddit">
            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12.017 0C5.396 0 ..."/>
            </svg>
          </a>
        </div>
      </div>
    </div>

    {/* Disclaimer */}
    <div className="border-t border-gray-200 pt-8 mb-8">
      <h3 className="text-gray-900 font-bold text-lg text-center mb-4">DISCLAIMER</h3>
      <p className="text-gray-600 text-center text-sm leading-relaxed max-w-5xl mx-auto">
        The information presented on this website is based on available scientific studies, material specifications, and user testimonials. The effectiveness of EMF-blocking materials may vary depending on use case and exposure levels. Emftitan does not guarantee outcomes and assumes no liability for product performance or health claims. Always consult a qualified professional for personalized advice.
      </p>
    </div>

    {/* Bottom Footer */}
    <div className="border-t border-gray-200 pt-8">
      <div className="flex flex-col lg:flex-row justify-between items-center">
        <p className="text-gray-500 text-sm mb-4 lg:mb-0">
          © 2025, EmfShopStream. All Rights Reserved.
        </p>
        <div className="flex space-x-4">
      {/* Visa */}
      <svg className="h-6" viewBox="0 0 38 24" xmlns="http://www.w3.org/2000/svg" role="img" width="38" height="24" aria-labelledby="pi-visa">
        <title id="pi-visa">Visa</title>
        <path opacity=".07" d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"></path>
        <path fill="#fff" d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"></path>
        <path d="M28.3 10.1H28c-.4 1-.7 1.5-1 3h1.9c-.3-1.5-.3-2.2-.6-3zm2.9 5.9h-1.7c-.1 0-.1 0-.2-.1l-.2-.9-.1-.2h-2.4c-.1 0-.2 0-.2.2l-.3.9c0 .1-.1.1-.1.1h-2.1l.2-.5L27 8.7c0-.5.3-.7.8-.7h1.5c.1 0 .2 0 .2.2l1.4 6.5c.1.4.2.7.2 1.1.1.1.1.1.1.2zm-13.4-.3l.4-1.8c.1 0 .2.1.2.1.7.3 1.4.5 2.1.4.2 0 .5-.1.7-.2.5-.2.5-.7.1-1.1-.2-.2-.5-.3-.8-.5-.4-.2-.8-.4-1.1-.7-1.2-1-.8-2.4-.1-3.1.6-.4.9-.8 1.7-.8 1.2 0 2.5 0 3.1.2h.1c-.1.6-.2 1.1-.4 1.7-.5-.2-1-.4-1.5-.4-.3 0-.6 0-.9.1-.2 0-.3.1-.4.2-.2.2-.2.5 0 .7l.5.4c.4.2.8.4 1.1.6.5.3 1 .8 1.1 1.4.2.9-.1 1.7-.9 2.3-.5.4-.7.6-1.4.6-1.4 0-2.5.1-3.4-.2-.1.2-.1.2-.2.1zm-3.5.3c.1-.7.1-.7.2-1 .5-2.2 1-4.5 1.4-6.7.1-.2.1-.3.3-.3H18c-.2 1.2-.4 2.1-.7 3.2-.3 1.5-.6 3-1 4.5 0 .2-.1.2-.3.2M5 8.2c0-.1.2-.2.3-.2h3.4c.5 0 .9.3 1 .8l.9 4.4c0 .1 0 .1.1.2 0-.1.1-.1.1-.1l2.1-5.1c-.1-.1 0-.2.1-.2h2.1c0 .1 0 .1-.1.2l-3.1 7.3c-.1.2-.1.3-.2.4-.1.1-.3 0-.5 0H9.7c-.1 0-.2 0-.2-.2L7.9 9.5c-.2-.2-.5-.5-.9-.6-.6-.3-1.7-.5-1.9-.5L5 8.2z" fill="#142688"></path>
      </svg>

      {/* Mastercard */}
      <svg className="h-6" viewBox="0 0 38 24" xmlns="http://www.w3.org/2000/svg" role="img" width="38" height="24" aria-labelledby="pi-master">
        <title id="pi-master">Mastercard</title>
        <path opacity=".07" d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"></path>
        <path fill="#fff" d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"></path>
        <circle fill="#EB001B" cx="15" cy="12" r="7"></circle>
        <circle fill="#F79E1B" cx="23" cy="12" r="7"></circle>
        <path fill="#FF5F00" d="M22 12c0-2.4-1.2-4.5-3-5.7-1.8 1.3-3 3.4-3 5.7s1.2 4.5 3 5.7c1.8-1.2 3-3.3 3-5.7z"></path>
      </svg>

      {/* Maestro */}
      <svg className="h-6" viewBox="0 0 38 24" xmlns="http://www.w3.org/2000/svg" width="38" height="24" role="img" aria-labelledby="pi-maestro">
        <title id="pi-maestro">Maestro</title>
        <path opacity=".07" d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"></path>
        <path fill="#fff" d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"></path>
        <circle fill="#EB001B" cx="15" cy="12" r="7"></circle>
        <circle fill="#00A2E5" cx="23" cy="12" r="7"></circle>
        <path fill="#7375CF" d="M22 12c0-2.4-1.2-4.5-3-5.7-1.8 1.3-3 3.4-3 5.7s1.2 4.5 3 5.7c1.8-1.2 3-3.3 3-5.7z"></path>
      </svg>

      {/* American Express */}
      <svg className="h-6" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 38 24" aria-labelledby="pi-american_express">
        <title id="pi-american_express">American Express</title>
        <g fill="none">
          <path fill="#000" d="M35,0 L3,0 C1.3,0 0,1.3 0,3 L0,21 C0,22.7 1.4,24 3,24 L35,24 C36.7,24 38,22.7 38,21 L38,3 C38,1.3 36.6,0 35,0 Z" opacity=".07"></path>
          <path fill="#006FCF" d="M35,1 C36.1,1 37,1.9 37,3 L37,21 C37,22.1 36.1,23 35,23 L3,23 C1.9,23 1,22.1 1,21 L1,3 C1,1.9 1.9,1 3,1 L35,1"></path>
          <path fill="#FFF" d="M8.971,10.268 L9.745,12.144 L8.203,12.144 L8.971,10.268 Z M25.046,10.346 L22.069,10.346 L22.069,11.173 L24.998,11.173 L24.998,12.412 L22.075,12.412 L22.075,13.334 L25.052,13.334 L25.052,14.073 L27.129,11.828 L25.052,9.488 L25.046,10.346 L25.046,10.346 Z M10.983,8.006 L14.978,8.006 L15.865,9.941 L16.687,8 L27.057,8 L28.135,9.19 L29.25,8 L34.013,8 L30.494,11.852 L33.977,15.68 L29.143,15.68 L28.065,14.49 L26.94,15.68 L10.03,15.68 L9.536,14.49 L8.406,14.49 L7.911,15.68 L4,15.68 L7.286,8 L10.716,8 L10.983,8.006 Z M19.646,9.084 L17.407,9.084 L15.907,12.62 L14.282,9.084 L12.06,9.084 L12.06,13.894 L10,9.084 L8.007,9.084 L5.625,14.596 L7.18,14.596 L7.674,13.406 L10.27,13.406 L10.764,14.596 L13.484,14.596 L13.484,10.661 L15.235,14.602 L16.425,14.602 L18.165,10.673 L18.165,14.603 L19.623,14.603 L19.647,9.083 L19.646,9.084 Z M28.986,11.852 L31.517,9.084 L29.695,9.084 L28.094,10.81 L26.546,9.084 L20.652,9.084 L20.652,14.602 L26.462,14.602 L28.076,12.864 L29.624,14.602 L31.499,14.602 L28.987,11.852 L28.986,11.852 Z"></path>
        </g>
      </svg>

      {/* Apple Pay */}
      <svg className="h-6" version="1.1" xmlns="http://www.w3.org/2000/svg" role="img" x="0" y="0" width="38" height="24" viewBox="0 0 165.521 105.965" xmlSpace="preserve" aria-labelledby="pi-apple_pay">
        <title id="pi-apple_pay">Apple Pay</title>
        <path fill="#000" d="M150.698 0H14.823c-.566 0-1.133 0-1.698.003-.477.004-.953.009-1.43.022-1.039.028-2.087.09-3.113.274a10.51 10.51 0 0 0-2.958.975 9.932 9.932 0 0 0-4.35 4.35 10.463 10.463 0 0 0-.975 2.96C.113 9.611.052 10.658.024 11.696a70.22 70.22 0 0 0-.022 1.43C0 13.69 0 14.256 0 14.823v76.318c0 .567 0 1.132.002 1.699.003.476.009.953.022 1.43.028 1.036.09 2.084.275 3.11a10.46 10.46 0 0 0 .974 2.96 9.897 9.897 0 0 0 1.83 2.52 9.874 9.874 0 0 0 2.52 1.83c.947.483 1.917.79 2.96.977 1.025.183 2.073.245 3.112.273.477.011.953.017 1.43.02.565.004 1.132.004 1.698.004h135.875c.565 0 1.132 0 1.697-.004.476-.002.952-.009 1.431-.02 1.037-.028 2.085-.09 3.113-.273a10.478 10.478 0 0 0 2.958-.977 9.955 9.955 0 0 0 4.35-4.35c.483-.947.789-1.917.974-2.96.186-1.026.246-2.074.274-3.11.013-.477.02-.954.022-1.43.004-.567.004-1.132.004-1.699V14.824c0-.567 0-1.133-.004-1.699a63.067 63.067 0 0 0-.022-1.429c-.028-1.038-.088-2.085-.274-3.112a10.4 10.4 0 0 0-.974-2.96 9.94 9.94 0 0 0-4.35-4.35A10.52 10.52 0 0 0 156.939.3c-1.028-.185-2.076-.246-3.113-.274a71.417 71.417 0 0 0-1.431-.022C151.83 0 151.263 0 150.698 0z"></path>
        <path fill="#FFF" d="M150.698 3.532l1.672.003c.452.003.905.008 1.36.02.793.022 1.719.065 2.583.22.75.135 1.38.34 1.984.648a6.392 6.392 0 0 1 2.804 2.807c.306.6.51 1.226.645 1.983.154.854.197 1.783.218 2.58.013.45.019.9.02 1.36.005.557.005 1.113.005 1.671v76.318c0 .558 0 1.114-.004 1.682-.002.45-.008.9-.02 1.35-.022.796-.065 1.725-.221 2.589a6.855 6.855 0 0 1-.645 1.975 6.397 6.397 0 0 1-2.808 2.807c-.6.306-1.228.511-1.971.645-.881.157-1.847.2-2.574.22-.457.01-.912.017-1.379.019-.555.004-1.113.004-1.669.004H14.801c-.55 0-1.1 0-1.66-.004a74.993 74.993 0 0 1-1.35-.018c-.744-.02-1.71-.064-2.584-.22a6.938 6.938 0 0 1-1.986-.65 6.337 6.337 0 0 1-1.622-1.18 6.355 6.355 0 0 1-1.178-1.623 6.935 6.935 0 0 1-.646-1.985c-.156-.863-.2-1.788-.22-2.578a66.088 66.088 0 0 1-.02-1.355l-.003-1.327V14.474l.002-1.325a66.7 66.7 0 0 1 .02-1.357c.022-.792.065-1.717.222-2.587a6.924 6.924 0 0 1 .646-1.981c.304-.598.7-1.144 1.18-1.623a6.386 6.386 0 0 1 1.624-1.18 6.96 6.96 0 0 1 1.98-.646c.865-.155 1.792-.198 2.586-.22.452-.012.905-.017 1.354-.02l1.677-.003h135.875"></path>
        <g>
          <g>
            <path fill="#000" d="M43.508 35.77c1.404-1.755 2.356-4.112 2.105-6.52-2.054.102-4.56 1.355-6.012 3.112-1.303 1.504-2.456 3.959-2.156 6.266 2.306.2 4.61-1.152 6.063-2.858"></path>
            <path fill="#000" d="M45.587 39.079c-3.35-.2-6.196 1.9-7.795 1.9-1.6 0-4.049-1.8-6.698-1.751-3.447.05-6.645 2-8.395 5.1-3.598 6.2-.95 15.4 2.55 20.45 1.699 2.5 3.747 5.25 6.445 5.151 2.55-.1 3.549-1.65 6.647-1.65 3.097 0 3.997 1.65 6.696 1.6 2.798-.05 4.548-2.5 6.247-5 1.95-2.85 2.747-5.6 2.797-5.75-.05-.05-5.396-2.101-5.446-8.251-.05-5.15 4.198-7.6 4.398-7.751-2.399-3.548-6.147-3.948-7.447-4.048"></path>
          </g>
          <g>
            <path fill="#000" d="M78.973 32.11c7.278 0 12.347 5.017 12.347 12.321 0 7.33-5.173 12.373-12.529 12.373h-8.058V69.62h-5.822V32.11h14.062zm-8.24 19.807h6.68c5.07 0 7.954-2.729 7.954-7.46 0-4.73-2.885-7.434-7.928-7.434h-6.706v14.894z"></path>
            <path fill="#000" d="M92.764 61.847c0-4.809 3.665-7.564 10.423-7.98l7.252-.442v-2.08c0-3.04-2.001-4.704-5.562-4.704-2.938 0-5.07 1.507-5.51 3.82h-5.252c.157-4.86 4.731-8.395 10.918-8.395 6.654 0 10.995 3.483 10.995 8.89v18.663h-5.38v-4.497h-.13c-1.534 2.937-4.914 4.782-8.579 4.782-5.406 0-9.175-3.222-9.175-8.057zm17.675-2.417v-2.106l-6.472.416c-3.64.234-5.536 1.585-5.536 3.95 0 2.288 1.975 3.77 5.068 3.77 3.95 0 6.94-2.522 6.94-6.03z"></path>
            <path fill="#000" d="M120.975 79.652v-4.496c.364.051 1.247.103 1.715.103 2.573 0 4.029-1.09 4.913-3.899l.52-1.663-9.852-27.293h6.082l6.863 22.146h.13l6.862-22.146h5.927l-10.216 28.67c-2.34 6.577-5.017 8.735-10.683 8.735-.442 0-1.872-.052-2.261-.157z"></path>
          </g>
        </g>
      </svg>

      {/* Bitcoin */}
      <svg className="h-6" viewBox="0 0 38 24" xmlns="http://www.w3.org/2000/svg" width="38" height="24" role="img" aria-labelledby="pi-bitcoin">
        <title id="pi-bitcoin">Bitcoin</title>
        <path opacity=".07" d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"></path>
        <path fill="#fff" d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"></path>
        <path fill="#EDA024" d="M21.6 4.4c-4.2-1.4-8.7.8-10.2 5s.8 8.7 5 10.2 8.7-.8 10.2-5c1.4-4.2-.8-8.7-5-10.2z"></path>
        <path fill="#fff" d="M16.1 8.3l.3-1c.6.2 1.3.4 1.9.7.2-.5.4-1 .5-1.6l.9.3-.5 1.5.8.3.5-1.5.9.3c-.2.5-.4 1-.5 1.6l.4.2c.3.2.6.4.9.7.3.3.4.6.5 1 0 .3 0 .6-.2.9-.2.5-.5.8-1.1.9h-.2c.2.1.3.2.4.4.4.4.5.8.4 1.4 0 .1 0 .2-.1.3 0 .1 0 .1-.1.2-.1.2-.2.3-.2.5-.3.5-.8.9-1.5.9-.5 0-1 0-1.4-.1l-.4-.1c-.2.5-.4 1-.5 1.6l-.9-.3c.2-.5.4-1 .5-1.5l-.8-.3c-.2.5-.4 1-.5 1.5l-.9-.3c.2-.5.4-1 .5-1.6l-1.9-.6.6-1.1c.2.1.5.2.7.2.2.1.4 0 .5-.2L17 9.3v-.1c0-.3-.1-.5-.4-.5 0-.2-.2-.3-.5-.4zm1.2 6c.5.2.9.3 1.3.4.3.1.5.1.8.1.2 0 .3 0 .5-.1.5-.3.6-1 .2-1.4l-.6-.5c-.3-.2-.7-.3-1.1-.4-.1 0-.3-.1-.4-.2l-.7 2.1zm1-3.1c.3.1.5.2.7.2.3.1.6.2.9.1.4 0 .7-.1.8-.5.1-.3.1-.6 0-.8-.1-.2-.3-.3-.5-.4-.3-.2-.6-.3-1-.4l-.3-.1c-.1.7-.4 1.3-.6 1.9z"></path>
      </svg>
    </div>
      </div>
    </div>
  </div>
</footer>

      </div>
    </div>
  );
};

export default Home;